import { useCallback } from "react";
import { useSearchParams } from "react-router-dom";

const CANVAS_SEARCH_TERM_PARAM = "canvas-search-term";

export const useCanvasSearchTermParam = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const searchTerm = searchParams.get(CANVAS_SEARCH_TERM_PARAM) ?? "";

  const setSearchTerm = useCallback(
    (value: string): void => {
      setSearchParams((params) => {
        if (value) {
          params.set(CANVAS_SEARCH_TERM_PARAM, value);
        } else {
          params.delete(CANVAS_SEARCH_TERM_PARAM);
        }
        return params;
      });
    },
    [setSearchParams],
  );

  const clearSearchTerm = useCallback((): void => {
    setSearchParams((params) => {
      params.delete(CANVAS_SEARCH_TERM_PARAM);
      return params;
    });
  }, [setSearchParams]);

  return {
    searchTerm,
    setSearchTerm,
    clearSearchTerm,
  };
};
